export default __webpack_public_path__ + "static/media/mini-12.8b0da53e.jpg";